import { useEffect } from 'react'
import { cn } from '@/lib/utils'
import { useCrmStore } from '@/stores/crm-store-provider'

export default function NoticeToast() {
    const notice = useCrmStore(state => state.notice)
    const clearNotice = useCrmStore(state => state.clearNotice)

    useEffect(() => {
        if (!notice) return

        const timer = window.setTimeout(clearNotice, 4000)

        return () => window.clearTimeout(timer)
    }, [notice, clearNotice])

    return (
        <div aria-live='polite' className='pointer-events-none fixed inset-x-4 bottom-4 z-[60] flex justify-center sm:inset-x-auto sm:right-4 sm:justify-end'>
            {notice && (
                <div
                    key={notice.id}
                    role={notice.tone === 'error' ? 'alert' : 'status'}
                    className='animate-in fade-in slide-in-from-bottom-2 border-line-strong bg-popover shadow-overlay pointer-events-auto flex max-w-[360px] items-center gap-2 rounded-lg border px-3 py-2.5 duration-200'
                >
                    <span
                        aria-hidden
                        className={cn('size-1.5 shrink-0 rounded-full', notice.tone === 'error' ? 'bg-danger' : 'bg-status')}
                    />
                    <span className='caption-style text-foreground leading-[1.3]'>
                        {notice.message}
                    </span>
                </div>
            )}
        </div>
    )
}
